window.addEventListener('load', function() {

	// make sure our code runs after the infinite product app
	setTimeout(function() {

		var textInputs = document.querySelectorAll('.hulkapps_option_set input');

		// add maxlength to text inputs
		textInputs.forEach(input => {
			input.setAttribute('maxlength', 8);
			input.addEventListener('keyup', forceNumeric);
		})

		// limit to only numeric input

	}, 500);

	function forceNumeric(){
	    var $input = $(this);
	    $input.val($input.val().replace(/[^\d\p{L}]+/g,''));
	}	

})